module.exports = __webpack_public_path__ + "img/DE06135.47f37fe3.svg";